import { render } from "./UnitsInput.vue?vue&type=template&id=1fae775c&scoped=true"
import script from "./UnitsInput.vue?vue&type=script&lang=js"
export * from "./UnitsInput.vue?vue&type=script&lang=js"

import "./UnitsInput.vue?vue&type=style&index=0&id=1fae775c&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fae775c"]])

export default __exports__